/**
 * Vuex.Store主入口
 * @author LiQingSong
 */
import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import user from "./modules/user";
import { getByKeys } from "../service/commonApi";
// import permission from "./modules/permission";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    openTopUp: false, // 打开充值弹窗
    showInvite: false, // 邀请好友弹窗
    currentMenu: 1,
    apolloConfig: {} // apollo配置
  },
  modules: {

    user,
    // permission,
  },
  mutations: {
    SET_OPEN_TOPUP(state, openTopUp) {
      state.openTopUp = openTopUp;
    },
    SET_SHOW_INVITE(state, showInvite) {
      state.showInvite = showInvite;
    },
    setCurrentMenu(state, val) {
      state.currentMenu = val;
    },
    SET_APOLLO_CONFIG(state, apolloConfig) {
      state.apolloConfig = apolloConfig;
    }
  },
  actions: {
    // 获取apollo配置
    getApolloConfig({ commit }, { nameSpace = "COMMON", keys = [] }) {
      return new Promise((resolve, reject) => {
        getByKeys({ nameSpace, keys, }).then((res) => {
          if (res.code === 1) {
            let configInfo = {}
            for (let key in res.data) {
              configInfo[key] = JSON.parse(res.data[key]);
            }
            commit("SET_APOLLO_CONFIG", configInfo);
            resolve(res.data);
          } else {
            reject(res.message);
          }
        });
      });
    }
  },
  getters
});
